import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import { demoApi } from '../../services/demoApi';
import { enterDemo, exitDemo } from '../demo';
import { ChartDataState } from '../chartData';

/**
 * Demo-mode reducer cases for the `chartData` slice.
 *
 * Pulled out of `chartData.ts` so it has no demo awareness — the slice calls
 * this one helper inside its `extraReducers`. Covers:
 *
 *  - `enterDemo` / `exitDemo` cache reset.
 *  - Two `demoApi` matchers that mirror the real-mode population path against
 *    the demo subs / single-sub details endpoints.
 */
export const applyDemoCasesToChartDataBuilder = (
  builder: ActionReducerMapBuilder<ChartDataState>,
) => {
  builder.addCase(enterDemo, (state) => {
    state.data = {};
  });
  builder.addCase(exitDemo, (state) => {
    state.data = {};
  });

  builder.addMatcher(
    demoApi.endpoints.getDemoSubscriptionsDetailsBatch.matchFulfilled,
    (state, { payload }) => {
      (payload?.subscriptionDetails ?? []).forEach((detail) => {
        if (detail?.chartData) {
          state.data[detail.id] = detail.chartData;
        }
      });
    },
  );

  builder.addMatcher(
    demoApi.endpoints.getDemoSubscriptionDetails.matchFulfilled,
    (state, { payload }) => {
      const detail = payload?.subscriptionDetails;
      if (detail?.chartData) {
        state.data[detail.id] = detail.chartData;
      }
    },
  );
};
